import { Chevron, Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import React, { ReactNode } from 'react'
import { FieldErrors, FieldValues } from 'react-hook-form'

type ListWithButtonAndChevronProps = {
  errors: FieldErrors<FieldValues> | null
  listItems: {
    name: string
    primaryText: string
    secondaryText?: string | ReactNode | null
    fields: string[]
    onClick: () => void
  }[]
}

export const ListWithButtonAndChevron: React.FC<ListWithButtonAndChevronProps> = ({ listItems, errors }) => {
  const { t } = useTranslateMessage()

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {listItems.map((item, index) => {
        const isError = item.fields.some((field) => errors && errors[field])
        const hasSecondaryText =
          item.secondaryText !== null && item.secondaryText !== undefined && item.secondaryText !== ''
        return (
          <React.Fragment key={index}>
            <ListItemButton divider onClick={item.onClick}>
              <ListItemText
                primary={item.primaryText}
                primaryTypographyProps={{
                  color: 'black',
                  fontSize: 15,
                  fontWeight: '500'
                }}
                secondary={
                  hasSecondaryText
                    ? item.secondaryText
                    : t({ id: 'form.item.notSet', defaultMessage: 'Please enter your details' })
                }
                secondaryTypographyProps={{
                  color: hasSecondaryText ? 'gray' : 'error.main',
                  fontSize: 14
                }}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              />
              <ListItemIcon
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  transform: 'rotate(270deg)',
                  height: '20px',
                  width: '20px'
                }}
              >
                <Chevron fill="grey" />
              </ListItemIcon>
            </ListItemButton>
            {isError && <Divider sx={{ bgcolor: 'error.main' }} />} {/* Show red divider if there's an error */}
          </React.Fragment>
        )
      })}
    </List>
  )
}
